import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {AssetDocument, AssetDocumentSearchParams} from '@accounting/_common/models/asset-document.models';

export const CheckState = createAction(
    '[AssetDocuments] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: AssetDocument[] } }>()
);

export const CheckStateSuccess = createAction(
    '[AssetDocuments] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: AssetDocument[] } }>()
);

export const LoadList = createAction(
    '[AssetDocuments] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[AssetDocuments] Load List Success',
    props<{ payload: { items: AssetDocument[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[AssetDocuments] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[AssetDocuments] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[AssetDocuments] Set Filter',
    props<{ payload: AssetDocumentSearchParams }>()
);

export const SetLoading = createAction(
    '[AssetDocuments] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[AssetDocuments] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[AssetDocuments] Update Item Success',
    props<{ payload: AssetDocument }>()
);

export const DeleteItem = createAction(
    '[AssetDocuments] Delete Item',
    props<{ payload: AssetDocument }>()
);

export const DeleteItemSuccess = createAction(
    '[AssetDocuments] Delete Item Success',
    props<{ payload: AssetDocument }>()
);

export const DeleteItemFailure = createAction(
    '[AssetDocuments] Delete Item Failure',
    props<{ payload: AssetDocument }>()
);

export const SetInitialState = createAction(
    '[AssetDocuments] Set Initial State'
);
